import React from "react";
import { useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// Import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import classes from "./artistNetworkCategories.module.css";
import {
  ARTIST_3,
  COMEDIAN,
  DANCE_GROUP,
  DANCER,
  DANCER_AND_ARENA,
  DJ,
  MAGICIAN,
  MUSICBAND,
  MUSICIAN,
  PHOTOGRAPHER,
  RAPPER,
  SINGER,
  SINGER_AND_ARENA,
  SPEAKER,
  VIDEO_EDITOR,
  VIDEO_EDITOR_AND_ARENA,
} from "../../utils/images";

const ArtistCategories = () => {
  const navigate = useNavigate();

  // Category data
  const categories = [
    {
      id: "singer",
      title: "Singer",
      description: "Hire the best Singer for your event!",
      image: SINGER, // Replace with actual image path
      count: 137,
      icon: "🎤",
    },
    {
      id: "dancer",
      title: "Dancer",
      description: "Amazing dancers for your special occasions",
      image: DANCER,
      count: 94,
      icon: "💃",
    },
    {
      id: "comedian",
      title: "Comedian",
      description: "Bring laughter to your events",
      image: COMEDIAN,
      count: 58,
      icon: "🎭",
    },
    {
      id: "magician",
      title: "Magician",
      description: "Create magical moments for your guests",
      image: MAGICIAN,
      count: 42,
      icon: "✨",
    },
    {
      id: "musician",
      title: "Musician",
      description: "Talented musicians for all occasions",
      image: MUSICIAN,
      count: 112,
      icon: "🎻",
    },
    {
      id: "music-band",
      title: "Music Band",
      description: "Energetic bands for unforgettable shows",
      image: MUSICBAND,
      count: 68,
      icon: "🎸",
    },
    {
      id: "dj",
      title: "DJ",
      description: "Keep the party alive with our professional DJs",
      image: DJ,
      count: 83,
      icon: "🎧",
    },
    {
      id: "beat-boxer",
      title: "Beat Boxer",
      description: "Unique beat-boxing talent for your events",
      image: SINGER,
      count: 31,
      icon: "🔊",
    },
    {
      id: "photographer",
      title: "Photographer",
      description: "Capture your special moments perfectly",
      image: PHOTOGRAPHER,
      count: 73,
      icon: "📸",
    },
    {
      id: "video-editor",
      title: "Video Editor",
      description: "Professional video editing services",
      image: VIDEO_EDITOR,
      count: 47,
      icon: "🎬",
    },
    {
      id: "dance-group",
      title: "Dance Group",
      description: "Coordinated dance performances for events",
      image: DANCE_GROUP,
      count: 52,
      icon: "👯",
    },
    {
      id: "speaker",
      title: "Speaker",
      description: "Engaging speakers for your conferences",
      image: SPEAKER,
      count: 38,
      icon: "🎙️",
    },
    {
      id: "rapper",
      title: "Rapper",
      description: "Energetic rap performances for your event",
      image: RAPPER,
      count: 45,
      icon: "🎵",
    },
  ];

  // Navigate to category page
  const navigateToCategory = (categoryId) => {
    navigate(`/categories/${categoryId}`);
  };

  return (
    <div id="artist-categories-container" className={classes.carouselSection}>
      <div className={classes.sectionHeader}>
        <h2 className={classes.sectionTitle}>Explore Artist Categories</h2>
        <p className={classes.sectionSubtitle}>
          Discover the perfect talent for your event or collaboration
        </p>
      </div>

      <Swiper
        slidesPerView={"auto"}
        spaceBetween={15}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation, Autoplay]}
        className={classes.swiperContainer}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={false}
        grabCursor={true}
        centeredSlides={false}
        breakpoints={{
          // Mobile
          320: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
          },
          // Tablet
          640: {
            slidesPerView: 2.2,
            spaceBetween: 15,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          // Desktop
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
        }}
      >
        {categories.map((category) => (
          <SwiperSlide
            key={category.id}
            className={classes.categorySlide}
            onClick={() => navigateToCategory(category.id)}
          >
            <div className={classes.categoryCard}>
              <div className={classes.imageContainer}>
                <img
                  src={category.image}
                  alt={category.title}
                  className={classes.categoryImage}
                  loading="lazy"
                />
                <div className={classes.iconBadge}>
                  <span>{category.icon}</span>
                </div>
                <div className={classes.overlay}></div>
              </div>
              <div className={classes.categoryInfo}>
                <h3 className={classes.categoryTitle}>{category.title}</h3>
                {/* <p className={classes.categoryCount}>
                  {category.count} Artists under review
                </p> */}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ArtistCategories;
